import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography'
import cx from 'classnames';
import {dateToDateTime} from 'data/converter';
import RemoveIcon from '@material-ui/icons/Clear';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import styles from './styles.module.sass';
import Question from 'components/common/Question';

class Comment extends PureComponent {
  render() {
    const {author, date, changeDate, changePersonName, children, publicFlag, className, onEdit, onRemove} = this.props;
    return (
      <Paper className={cx('Comment', styles.box, className)}>
        <div className={styles.header}>
          <div className={styles.headerLeftBox}>
            <div className={styles.author}>{author}</div>
            {publicFlag && <div className={styles.time}>публичный</div>}
            <div className={styles.time}>{dateToDateTime(date)}</div>
            {(changeDate || changePersonName) && <div className={styles.time}>(изменен {changePersonName !== author ? changePersonName + ' ' : ''}{dateToDateTime(changeDate)})</div>}
          </div>
          <div className={styles.headerRightBox}>
            {onEdit &&
            <Tooltip title={'Редактировать'}>
              <IconButton style={{width: '25px', height: '25px'}} onClick={onEdit}>
                <EditIcon style={{color: '#37474F', width: '15px'}}/>
              </IconButton>
            </Tooltip>
            }
            {onRemove &&
            <Question header={'Вы уверены что хотите удалить комментарий?'} onOk={onRemove}>
              <Tooltip title={'Удалить'}>
                <IconButton style={{width: '25px', height: '25px'}}>
                  <RemoveIcon style={{color: '#b71c1c', width: '20px'}}/>
                </IconButton>
              </Tooltip>
            </Question>
            }
          </div>
        </div>
        <div className={styles.body}>
          <pre className={styles.text}><Typography>{children}</Typography></pre>
        </div>
      </Paper>
    );
  }
}

Comment.propTypes = {
  className: PropTypes.string,

  author: PropTypes.string,
  date: PropTypes.string,
  changeDate: PropTypes.string,
  changePersonName: PropTypes.string,
  publicFlag: PropTypes.bool,

  onEdit: PropTypes.func,
  onRemove: PropTypes.func,
};

export default Comment;


// WEBPACK FOOTER //
// ./src/components/common/Comment/Comment.jsx